export default __webpack_public_path__ + "images/SpeakersPhotos/Eduardo_Lazcano.jpg?6aeef70d";